import {Helmet} from "react-helmet";
import {NavLink, withRouter} from "react-router-dom";
import API from "../../api";
import {withSnackbar} from "notistack";
import {BASE_URL, validateEmail, hideAlertAfterDelay} from "../../helper";
import "../../assets/css/errors.css";
import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import "react-phone-number-input/style.css";
import {setUserInfo} from "../../actions/user";
import {updateCart} from "../../actions/cart";
import {updateList} from "../../actions/list";
import {connect} from "react-redux";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import queryString from "querystring";
import 'react-datepicker/dist/react-datepicker.css';
import React from "react";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import ReCAPTCHA from "react-google-recaptcha";

const api = new API();
const eye = <FontAwesomeIcon icon={faEye} style={{ color: '#56aac5' }} />;
const closeEye = <FontAwesomeIcon icon={faEyeSlash} style={{ color: '#56aac5' }} />;

class SignUp extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      SignUpData: {
        first_name: "",
        last_name: "",
        email: "",
        contact_number: "",
        date_of_birth: '',
        password: "",
        email_subscription: true,
        term_condition:true,
        // clientID: "282384162289-gp4ve43bm00n3hgu09keva40i6n44au6.apps.googleusercontent.com",
      },
      errors: {},
      checkout: false,
      loading: false,
      errorAlert: null,
      redirect_url : "",
      startDate : new Date(),
      currentDate : new Date(),
      showPassword : false,
      touched: this.getInitialTouchedState(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEvenPhone = this.handleEvenPhone.bind(this);
    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.numberRef = React.createRef();
    this.emailRef = React.createRef();
    this.passwordRef = React.createRef();
    this.alertBox = React.createRef();
    this.dobRef =  React.createRef();
    this.dobInputRef = React.createRef();
    this.recaptchaRef = React.createRef();
  }

  componentDidMount() {
    if (
        this.props.cookies.get("token") &&
        this.props.cookies.get("token") !== undefined &&
        this.props.cookies.get("token") !== ""
    ) {
      this.props.history.push("/");
    }
    if (
        this.props.cookies.get("toggle") &&
        this.props.cookies.get("toggle") !== undefined &&
        this.props.cookies.get("toggle") === "toggled"
    ) {
      this.props.cookies.set("toggle", "");
    }

    const params = queryString.parse(this.props.location.search);
    if (params && params['?ref'] !== this.state.redirect_url){
      this.setState({redirect_url :  params['?ref'] !== undefined ? params['?ref'] : "" })
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
        this.props.cookies.get("toggle") &&
        this.props.cookies.get("toggle") !== undefined &&
        this.props.cookies.get("toggle") === "toggled"
    ) {
      this.props.cookies.set("toggle", "");
    }
  }

  getSignUpFieldNames() {
    return ["first_name", "last_name", "email", "contact_number", "date_of_birth", "password"];
  }

  getInitialTouchedState() {
    return this.getSignUpFieldNames().reduce((touched, name) => {
      touched[name] = false;
      return touched;
    }, {});
  }

  getAllTouchedState() {
    return this.getSignUpFieldNames().reduce((touched, name) => {
      touched[name] = true;
      return touched;
    }, {});
  }

  getFieldRef(name) {
    const refs = {
      first_name: this.firstNameRef,
      last_name: this.lastNameRef,
      email: this.emailRef,
      contact_number: this.numberRef,
      date_of_birth: this.dobRef,
      password: this.passwordRef,
    };

    return refs[name];
  }

  sanitizeFieldValue(name, value, type, checked) {
    if (type === "checkbox") {
      return checked;
    }

    let updatedValue = (value || "").toString().trim();

    if (name === "first_name" || name === "last_name") {
      // Keep names API-safe while preserving a single internal space.
      updatedValue = updatedValue
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ");
    }

    return updatedValue;
  }

  getFieldValidationError(name, value) {
    if (name === "first_name") {
      return !value ? "Enter first name" : "";
    }

    if (name === "last_name") {
      return !value ? "Enter last name" : "";
    }

    if (name === "email") {
      return !value || !validateEmail(value) ? "Enter valid email address" : "";
    }

    if (name === "contact_number") {
      return !value || value.length < 10 ? "Enter valid phone number" : "";
    }

    if (name === "date_of_birth") {
      if (!value) {
        return "";
      }

      return value.length < 10 ? "Enter valid date of birth" : this.validateDOB(value);
    }

    if (name === "password") {
      return !value ? "Enter password" : "";
    }

    return "";
  }

  getFormValidationErrors(signUpData = this.state.SignUpData) {
    const errors = {};

    this.getSignUpFieldNames().forEach((name) => {
      const error = this.getFieldValidationError(name, signUpData[name]);

      if (error) {
        errors[name] = error;
      }
    });

    return errors;
  }

  getUpdatedErrorsForField(name, value, errors = this.state.errors) {
    const updatedErrors = {...errors};
    const fieldError = this.getFieldValidationError(name, value);

    if (fieldError) {
      updatedErrors[name] = fieldError;
    } else {
      delete updatedErrors[name];
    }

    return updatedErrors;
  }

  showValidationErrors(errors) {
    this.setState({
      errors,
      errorAlert: null,
      touched: this.getAllTouchedState(),
    });
  }

  scrollToFirstError(errors) {
    const firstErrorName = this.getSignUpFieldNames().find((name) => errors[name]);
    const errorRef = this.getFieldRef(firstErrorName);

    errorRef?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  showTimedErrorAlert(message, shouldScroll = false) {
    this.setState({errorAlert: message}, () => {
      if (shouldScroll) {
        this.alertBox.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });

    if (this.alertTimeout) {
      clearTimeout(this.alertTimeout);
    }

    this.alertTimeout = hideAlertAfterDelay(() => {
      this.setState({errorAlert: null});
    });
  }

  validateFormBeforeSubmit() {
    const errors = this.getFormValidationErrors();

    if (Object.keys(errors).length > 0) {
      this.showValidationErrors(errors);
      this.scrollToFirstError(errors);
      return false;
    }

    if (this.state.SignUpData.term_condition === false) {
      this.setState({errors: {}});
      this.showTimedErrorAlert("Accept Terms and Conditions.", true);
      return false;
    }

    this.setState({errors: {}, errorAlert: null});
    return true;
  }

  handleChange(event) {
    const { name, value, type, checked } = event.target;
    const updatedValue = this.sanitizeFieldValue(name, value, type, checked);
    const SignUpData = {...this.state.SignUpData, [name]: updatedValue};
    let errors = {...this.state.errors};

    // Keep first typing quiet; touched fields validate on change so visible errors clear immediately.
    if (this.state.touched[name]) {
      errors = this.getUpdatedErrorsForField(name, updatedValue, errors);
    }

    this.setState({
      SignUpData,
      errors,
      errorAlert: null,
    });
  }

  handleBlur(event) {
    const {name} = event.target;

    this.setState({
      touched: {
        ...this.state.touched,
        [name]: true,
      },
      errors: this.getUpdatedErrorsForField(name, this.state.SignUpData[name]),
    });
  }

  handleEvenPhone(event) {
    this.handleChange({
      target: {
        value: event,
        name: "contact_number",
      },
    });
  }

  handleSubmit(event) {

    event.preventDefault();

    // Local validation runs before reCAPTCHA so invalid forms do not trigger captcha work.
    if (!this.validateFormBeforeSubmit()) {
      return false;
    }

    this.recaptchaRef.current.execute();
  }

  handleDateChange = (e) => {
    const {name, value} = e.target;
    const {selectionStart} = e.target;
    const formattedValue = this.formatDOB(value);
    const formattedCursorPosition = this.calculateCursorPosition(value, selectionStart, formattedValue);
    const errors = this.state.touched[name]
        ? this.getUpdatedErrorsForField(name, formattedValue)
        : this.state.errors;

    this.setState(() => ({
      SignUpData: {
        ...this.state.SignUpData,
        [name]: formattedValue
      },
      errors,
      errorAlert: null,
    }), () => {
      this.dobInputRef.current?.setSelectionRange(formattedCursorPosition, formattedCursorPosition);
    });
  };

  calculateCursorPosition = (originalValue, originalCursorPosition, formattedValue) => {
    let formattedCursorPosition = originalCursorPosition;

    if (originalValue.length < formattedValue.length && originalValue.length === 2) {
      formattedCursorPosition += 1;
    } else if (originalValue.length > formattedValue.length && originalValue.length === 3) {
      formattedCursorPosition += 1;
    } else if (originalValue.length < formattedValue.length && originalValue.length === 5) {
      formattedCursorPosition += 1;
    } else if (originalValue.length > formattedValue.length && originalValue.length === 6) {
      formattedCursorPosition += 1;
    } else if (originalValue.length === originalCursorPosition) {
      formattedCursorPosition += 2;
    }

    return formattedCursorPosition;
  };

  formatDOB = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 2) {
      return cleaned;
    }
    if (cleaned.length <= 4) {
      return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
    }
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
  };

  validateDOB = (value) => {
    if (!value) {
      return ''
    }

    const [monthPart = '', dayPart = '', yearPart = ''] = value.split('/');
    const month = parseInt(monthPart, 10);
    const day = parseInt(dayPart, 10);
    const year = parseInt(yearPart, 10);
    const daysInMonth = new Date((year || 2010), month, 0).getDate();
    const minYear = new Date().getFullYear() - 15;

    if (monthPart.length === 2 && (isNaN(month) || month < 1 || month > 12)) {
      return 'Invalid month. Use leading zero for single digits.';
    }
    if (dayPart.length === 2 && (isNaN(day) || day < 1 || day > daysInMonth)) {
      return 'Invalid date. Use leading zero for single digits.';
    }
    if (yearPart.length === 4 && (isNaN(year) || year > minYear)) {
      return 'You must be at least 15 years old';
    }
    if (yearPart.length === 4 && (isNaN(year) || year < 1900)) {
      return 'Invalid year';
    }
    return '';
  };

  onReCAPTCHAChange = (token) => {

    this.setState({errorAlert: null});

    if (!this.validateFormBeforeSubmit()) {
      this.recaptchaRef.current.reset();
      return false;
    }

    const payload = {...this.state.SignUpData};
    if (!!this.state.SignUpData.date_of_birth) {
      payload.date_of_birth = payload.date_of_birth?.replaceAll('/', '-');
    }

    payload.confirm_password = payload.password;
    payload.captcha_token = token;

    api.signUp(
        payload,
        this.props.cookies.get("cart_id")
            ? this.props.cookies.get("cart_id")
            : "blank",
        this.props.cookies.get("list_unique_id")
            ? this.props.cookies.get("list_unique_id")
            : "default"
    )
        .then((success) => {
          const {cookies} = this.props;
          const token = success.data.response.token;
          const data = {};
          data.user = success.data.response;

          const oneYearFromNow = new Date();
          oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

          cookies.set("token", token, {expires: oneYearFromNow});
          cookies.set("list_unique_id", success.data.response?.list_unique_id ? success.data.response?.list_unique_id : "default", {expires: oneYearFromNow});
          cookies.set("store_modal", false, {expires: oneYearFromNow});
          cookies.set("toggle", "", {expires: oneYearFromNow});

          localStorage.setItem('auth_user', success.data.response.first_name + " " + success.data.response.last_name);

          this.setState({token});
          this.props.updateUserList({token: token});
          this.props.updateCartItems({cart_id: "blank", token: token});
          this.props.userInfo(data);
          this.props.history.push("/" + this.state.redirect_url);
        })
        .catch((error) => {
          this.recaptchaRef.current.reset();
          this.showTimedErrorAlert(error?.response?.data?.message || "Something went wrong. Please try again.");
        });
  };

  render() {

    return (
        <React.Fragment>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Sign Up - Farmer&#039;s Fresh Meat: Houston Meat Market &amp;
              Butcher Shop</title>
            <meta name="theme-color" content="#48750C"/>
            <meta name="description" content="Helmet application" />
            <meta name="robots" content="index, follow" />
            <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="About - Buy The Best Crown Ribeye Roast Meat And Boudin Balls!" />
            <meta property="og:description" content="Get the best crown roast meat at the lowest price from Farmer’s Fresh Meat shop. We offer the fresh ribeye roast meat and boudin balls meat products in Houston, Texas." />
            <meta property="og:url" content={ BASE_URL() + this.props.location.pathname} />
            <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop" />
            <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat" />
            <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00" />
            <meta property="og:image:width" content="1449" />
            <meta property="og:image:height" content="1024" />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:creator" content="Farmerfreshmeat" />
            <meta name="twitter:site" content="Farmerfreshmeat" />
            <link rel="canonical" href={ BASE_URL() +this.props.location.pathname} />
            <script type="application/ld+json"
                    className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
          </Helmet>
          <section className="main-height form-view d-block pb-5 bg-white pt-2">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6 px-md-5 mx-auto">
                  <div className="bg-white border-1 main-section p-3 p-md-5">
                    <div className="signin-info text-center mt-0">
                      <h1 className="mb-2">Sign up</h1>
                      <p className="font-weight-normal mb-2">Unlock instant savings with your account!</p>
                      <div className="col-12 create-account mb-4 text-center ">
                        <p className=" font-weight-normal">
                            <span className="font-weight-normal text-black">Already have an account ?&nbsp;</span>
                            <NavLink className="more-info float-none fs-14" exact to="/login">
                            <span className='text-decoration-underline pointer font-weight-medium'>Login here</span>
                          </NavLink>
                        </p>
                      </div>
                    </div>

                    {this.state.errorAlert ? (
                        <div
                            ref={this.alertBox}
                            role="alert"
                            class="sc-1wz9i2x-0 fooVeK"
                        >
                          <svg
                              width="1792"
                              height="1792"
                              viewBox="0 0 1792 1792"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              class="sc-1t1e23j-0 bbiirI"
                          >
                            <path
                                fill="currentColor"
                                d="M1024 1375v-190q0-14-9.5-23.5T992 1152H800q-13 0-22.5 9.5T768 1185v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11H786q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17H128q-34 0-63.5-17T18 1601q-37-63-2-126L784 67q17-31 47-49t65-18 65 18 47 49z"
                            ></path>
                          </svg>
                          <span style={{whiteSpace: 'pre-line'}}>{this.state.errorAlert}</span>
                        </div>
                    ) : null}
                    <form>
                      <div className="row">
                        <div ref={this.firstNameRef} className="form-group col-md-6 pr-md-2 mb-0 mb-md-1">
                          <input
                              type="text"
                              className={
                                "form-control valid-control " +
                                (this.state.errors.first_name ? " invalid" : "")
                              }
                              id="first_name"
                              name="first_name"
                              placeholder="First name*"
                              value={this.state.SignUpData.first_name}
                              onChange={this.handleChange}
                              onBlur={this.handleBlur}
                              maxLength="25"
                          />
                          <small className="error-text mt-1 mb-3">
                            {this.state.errors.first_name}
                          </small>
                        </div>

                        <div ref={this.lastNameRef} className="form-group col-md-6 pl-md-3 mb-0 mb-md-1">
                          <input
                              type="text"
                              className={
                                "form-control valid-control " +
                                (this.state.errors.last_name ? "invalid" : "")
                              }
                              id="last_name"
                              name="last_name"
                              placeholder="Last name*"
                              value={this.state.SignUpData.last_name}
                              onChange={this.handleChange}
                              onBlur={this.handleBlur}
                              maxLength="25"
                          />
                          <small className="error-text mt-1 mb-3">
                            {this.state.errors.last_name}
                          </small>
                        </div>
                      </div>

                      <div className="row">
                        <div ref={this.emailRef} className="form-group col-12">
                        <input
                            type="email"
                            className={
                              "form-control valid-control " +
                              (this.state.errors.email ? "invalid" : "")
                            }
                            id="email"
                            name="email"
                            placeholder="Email*"
                            value={this.state.SignUpData.email}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                        />
                          <small className="error-text mt-1 mb-2">
                          {this.state.errors.email}
                        </small>
                      </div>
                      </div>
                      <div className="row">
                        <div ref={this.numberRef} className="form-group col-12">
                        <PhoneInput
                            placeholder="Phone*"
                            inputClass={"valid-control " + (this.state.errors.contact_number ? "invalid" : "")}
                            country={'us'}
                            disableCountryGuess={true}
                            disableCountryCode={true}
                            disableDropdown={true}
                            value={this.state.SignUpData.contact_number}
                            onChange={this.handleEvenPhone}
                            onBlur={() => this.handleBlur({target: {name: "contact_number"}})}
                        />
                          <small className="error-text mt-1 mb-2">
                          {this.state.errors.contact_number}
                        </small>
                      </div>
                      </div>
                      <div className="row">
                        <div ref={this.dobRef} className="form-group col-12">
                        <input
                            type="text"
                            className={
                              "form-control valid-control " +
                              (this.state.errors.date_of_birth ? "invalid" : "")
                            }
                            name='date_of_birth'
                            id='date_of_birth'
                            placeholder="MM/DD/YYYY"
                            value={this.state.SignUpData.date_of_birth}
                            onChange={this.handleDateChange}
                            onBlur={this.handleBlur}
                            ref={this.dobInputRef}
                        />
                       {!!this.state.errors.date_of_birth &&
                       <small className="error-text mt-1 mb-2">
                          {this.state.errors.date_of_birth}
                        </small>}
                          <small className="text-muted">Enter your birthday for delightful surprises (optional)</small>
                      </div>
                      </div>
                      <div className="row">
                        <div ref={this.passwordRef} className="form-group col-12">
                        <input
                            type={this.state.showPassword ? "text" : "password"}
                            className={"form-control valid-control " + (this.state.errors.password ? "invalid" : "")}
                            id="password"
                            name="password"
                            placeholder="Password*"
                            value={this.state.SignUpData.password}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            maxLength="25"
                        />

                        <i className="hidePassword"
                           onClick={() => this.setState({showPassword: !this.state.showPassword})}>
                            {this.state.showPassword ? eye : closeEye}
                          </i>
                        <small className="text-muted ">8 characters | No spaces</small>
                          <small className="error-text mt-1 mb-2">
                          {this.state.errors.password}
                        </small>
                      </div>
                      </div>

                      <div className="form-captcha">
                        <ReCAPTCHA
                            ref={this.recaptchaRef}
                            sitekey={process.env.RAZZLE_RECAPTCHA_SITE_KEY}
                            onChange={this.onReCAPTCHAChange}
                            size={"invisible"}
                        />
                      </div>

                      <div className="row mb-3">
                        <div className="col-12 update-btn text-center mb-3 pb-15">
                          <button onClick={this.handleSubmit} className="btn btn-m cart-button w-100 mb-2">
                            Create account
                          </button>
                        </div>
                        <div className="col-12 custom-check login-check mb-0">
                          <label htmlFor='term_condition'
                                 className="control control--checkbox mb-0 text-black t-70 font-weight-normal">
                            By creating an account, I agree to receive emails with coupons, deals, and more, and to
                            adhere to the Farmer’s Fresh Meat {' '}
                            <NavLink exact to={'/terms-and-condition'}>
                              <span className="">Terms & Conditions</span>
                            </NavLink>.
                            <input
                                type="checkbox"
                                id='term_condition'
                                name="term_condition"
                                checked={this.state.SignUpData.term_condition}
                                value={this.state.SignUpData.term_condition}
                                onChange={this.handleChange}
                            />
                            <div className="control__indicator"></div>
                          </label>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    userInfo: (data) =>
        dispatch(setUserInfo({type: "GET_USER_INFO", data: data})),
    updateCartItems: (val) =>
        dispatch(updateCart({type: "UPDATE_CART_ITEMS", data: val})),
    updateUserList: (val) =>
        dispatch(updateList({type: "USER_LIST", data: val})),
  };
};
export default withRouter(
    withCookies(withSnackbar(connect(null, mapDispatchToProps)(SignUp)))
);
